module.exports = __webpack_public_path__ + "static/img/step03.8778a78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/applyprocess/step03.png
// module id = dHC/
// module chunks = 1